/**
 * BODYSCROLL MODULE
 *
 * Handles disabling/enabling body scroll during modal popup
 */

VP = window.VP || {};

(function( $ ) {

	/**
	 * PRIVATE VARIABLES
	 */
	var SELECTOR = {
		html: 'html',
		// Elements that have to set width in order to account for the scrollbar's width
		// Usually these are fix-positioned elements
		widthReferenceElements: '.vp-module__featured-hero, .vp-header'
	};


	// Creates temporary DOM elements to compute for the scrollbar width
	function getScrollbarWidth () {
		var $el = $('<div>');
		var scrollBarWidth = 0;

		// Insert to DOM
		$el
		.appendTo( VP.bodyScroll.$html )
		.css({
			overflow: 'scroll',
			width: '100px',
			heigth: '100px',
		});

		// Compute for scrollbar width
		// 	- clientWidth: width excluding scrollbar
		// 	- offsetWidth: width including scrollbar
		scrollBarWidth = $el[0].offsetWidth - $el[0].clientWidth;

		// Remove from DOM
		$el.remove();

		return scrollBarWidth;
	}


	/**
	 * BODYSCROLL MODULE ATTACHED TO APP
	 */
	VP.bodyScroll = {

		// Stores computed scrollbar width
		scrollBarWidth: 0,

		$html: $(SELECTOR.html),

		init: function () {
			this.scrollBarWidth = getScrollbarWidth();
		},

		// Disables body scroll
		disable: function () {
			this.$html.css({
				overflow: 'hidden',
				'padding-right': this.scrollBarWidth + 'px'
			});
			$(SELECTOR.widthReferenceElements).css({
				width: 'calc(100% - '+ this.scrollBarWidth +'px)'
			});
		},

		// Enables body scroll
		enable: function () {
			this.$html.css({
				overflow: '',
				'padding-right': ''
			});
			$(SELECTOR.widthReferenceElements).css({
				width: ''
			});
		}

	};
})(jQuery);
